import { Typography } from '@mui/material';
import { useAuth } from 'context/auth';
import { colors } from 'crono-fe-common/theme';
import { ReactComponent as LogoutIcon } from 'crono-fe-common/icons/Log-Out.svg';
import { LogoutButtonWrapper } from './style';

const LogoutButton = () => {
  const { logout } = useAuth();

  return (
    <LogoutButtonWrapper onClick={() => logout()}>
      <LogoutIcon />

      <Typography
        fontSize={14}
        lineHeight={'24px'}
        fontWeight={500}
        color={colors.grey11}
      >
        Log out
      </Typography>
    </LogoutButtonWrapper>
  );
};

export default LogoutButton;
